import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorStrings } from 'src/app/constants/form.constants';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { atLeastOneCheckboxToBeCheckedValidator } from 'src/app/shared/utils/utils';
import { ThirdPartyCommunicationStepStates, User } from 'src/app/interfaces/user';
import { UserService } from 'src/app/services/user/user.service';
import { UpdateSocialLoginUserDetailsDTO } from 'src/app/interfaces/Account/updateSocialLoginUserDetailsDTO';

@Component({
  selector: 'app-social-login-register',
  templateUrl: './social-login-register.component.html',
  styleUrls: ['./social-login-register.component.scss']
})
export class SocialLoginRegisterComponent implements OnInit {

  public loading = false;
  public userData: User;
  public errorStrings = ErrorStrings;
  public model = {
    emailAddress: ''
  };
  public communicationForm: UntypedFormGroup;
  public thirdPartyCheckboxStateChanged = false;

  constructor(
    private _router: Router,
    private _fb: UntypedFormBuilder,
    private _userService: UserService

  ) {
    this.userData = this._router.getCurrentNavigation().extras.state as User;
    if (this.userData == null) {
      this._router.navigate(['/']);
    }
  }

  ngOnInit(): void {
    this.initEmailAddress();
    this.initCommunicationForm();
  }

  public onSubscribeOptionChanged(event) {
    this.thirdPartyCheckboxStateChanged = true;
    if (event.target.checked) {
      if (event.target.id === 'subscribeToAllThirdParty') {
        // tslint:disable-next-line: no-string-literal
        this.communicationForm.controls['thirdPartySubscribeOptionSelectGroup'].get('unsubscribeFromAllThirdParty').setValue(false);
      } else {
        // tslint:disable-next-line: no-string-literal
        this.communicationForm.controls['thirdPartySubscribeOptionSelectGroup'].get('subscribeToAllThirdParty').setValue(false);
      }
    }
  }

  public finalizeSocialUserData() {
    this.loading = true;
    const socialLoginUserData: UpdateSocialLoginUserDetailsDTO = {
      userData: {
        email: this.model.emailAddress,
        thirdPartyCommStepCompleted: ThirdPartyCommunicationStepStates.Updated
      },
      userCommunicationData: {
        newsAndUpdatesEmail: !this.communicationForm.get('subscribeToAllInternalCommunication').value,
        newsAndUpdatesSms: !this.communicationForm.get('subscribeToAllInternalCommunication').value,
        newsAndUpdatesTelephone: !this.communicationForm.get('subscribeToAllInternalCommunication').value,
        thirdPartyCommunicationEmail: this.communicationForm.get('thirdPartySubscribeOptionSelectGroup.subscribeToAllThirdParty').value,
        thirdPartyCommunicationSms: this.communicationForm.get('thirdPartySubscribeOptionSelectGroup.subscribeToAllThirdParty').value
      }
    };

    this._userService.initUpdateSocialLoginUserDetails(this.userData.id, socialLoginUserData)
      .subscribe(
        (response) => {
          if (response.token) {
            this._router.navigate(['/dashboard']);
          }
        },
        err => {
          console.log('Error happened during social init update: ', err);
        }
    )
    .add(() => {
      this.loading = false;
    });
  }

  private initEmailAddress() {
    this.model.emailAddress = this.userData.contact?.email;
  }

  private initCommunicationForm() {
    this.communicationForm = this._fb.group({
      subscribeToAllInternalCommunication: [false],
      thirdPartySubscribeOptionSelectGroup: new UntypedFormGroup({
        subscribeToAllThirdParty: new UntypedFormControl(false),
        unsubscribeFromAllThirdParty: new UntypedFormControl(false)
      }, atLeastOneCheckboxToBeCheckedValidator())
    });
  }

}
